export const GET_CONFIGURATIONS = "GET_CONFIGURATIONS";
export const GET_CONFIGURATION_BY_ID = "GET_CONFIGURATION_BY_ID";
export const UPDATE_CONFIGURATION = "UPDATE_CONFIGURATION";
export const DELETE_CONFIGURATION = "DELETE_CONFIGURATION";
export const CREATE_CONFIGURATION = "CREATE_CONFIGURATION";
